<div
  #contentEl
  class="ellipsis"
  [style.-webkit-line-clamp]="lines"
  [ngbTooltip]="tooltipText"
  [disableTooltip]="!isTruncated">
  <ng-content></ng-content>
</div>

